import PropTypes from 'prop-types';
import styled from 'styled-components';

const DivProductListImage = styled.div` 
  position: relative;
  text-align: center;


  .hasBadges .image {
    margin-bottom: 0;
  }

  a {
    padding-bottom: 10px;
  }

  .image {
    width: 100%;
  }

  img.product-image, .product-image img {
    width: 100%;
    height: auto;
    background: #ffffff;
    color: #213038;
    display: inline-block;
  }

  .sticker {
    position: absolute;
    top: -1px;
    left: -4px;
  }

  .badges {
    box-sizing: border-box;
    display: block;
    margin-top: 0;
    padding: 10px 0;
  }

  &.sponsored {
    .productListImage .sticker {
      top: 2px;
    }
  }

`;

const GridItemTopImageAndBadges = ({ link, icons, stickerImage, loadImages, image }) => (
  <DivProductListImage className={'productListImage'}>
    <a
      href={link}
      className={`imgC ${icons ? 'hasBadges' : ''}`}
    >
      <div
        className={'product-images'}
      >
        {stickerImage && (
          <div className={'sticker stickerImg'}>
            {loadImages && (
            <img
              src={stickerImage.src}
              alt={stickerImage.alt ? stickerImage.alt : undefined}
            />
            )}
          </div>
        )}
        <img
          className={'image product-image'}
          src={loadImages ? image.src : ''}
          alt={image.label}
          width={'250'}
          height={'213'}
        />
      </div>
    </a>
    {icons
      ? (
        <div
          className={'badges desktop'}
        >
          {icons.map((badge, i) => (
            <a
                // eslint-disable-next-line react/jsx-no-target-blank
              target={'_blank'}
              href={badge.linkUrl ? badge.linkUrl : ''}
              rel={'noopener noreferrer'}
                // eslint-disable-next-line react/no-array-index-key
              key={i}
            >
              {loadImages && (
                <img
                  src={badge.imgUrl}
                  alt={''}
                />
              )}
            </a>
          ))}
        </div>
      )
      : (
        <a
          className={'badges desktop'}
          href={link}
        >
          &nbsp;
        </a>
      )}
  </DivProductListImage>
);

GridItemTopImageAndBadges.propTypes = {
  icons: PropTypes.arrayOf(
    PropTypes.shape({
      imgUrl: PropTypes.string.isRequired,
      linkUrl: PropTypes.string
    })
  ),
  image: PropTypes.shape({
    src: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired
  }).isRequired,
  link: PropTypes.string.isRequired,
  loadImages: PropTypes.bool,
  stickerImage: PropTypes.shape({
    src: PropTypes.string.isRequired,
    alt: PropTypes.string
  })
};

GridItemTopImageAndBadges.defaultProps = {
  icons: undefined,
  loadImages: false,
  stickerImage: undefined
};

export default GridItemTopImageAndBadges;
